import React, { useEffect } from 'react';
import './GridSync.css';

const imageSections = [
  {
    src: '/GridSync_Dashboard.png',
    title: 'Dashboard',
    description: 'The Dashboard provides a snapshot of clients, schedules, and groups. Quickly monitor the health and status of your digital signage network.',
  },
  {
    src: '/GridSync_Dashboard_Schedules.png',
    title: 'Dashboard – Active Schedules',
    description: 'View active and inactive schedules directly from the dashboard, including timing, assigned designs, and client assignments.',
  },
  {
    src: '/GridSync_Dashboard_Groups.png',
    title: 'Dashboard – Groups Overview',
    description: 'See your groups at a glance, including their assigned clients and schedules.',
  },
  {
    src: '/GridSync_Clients.png',
    title: 'Clients',
    description: 'Manage all connected client devices, view their online status, and perform actions like rename, delete, or restart.',
  },
  {
    src: '/GridSync_Content.png',
    title: 'Content Library',
    description: 'Upload and manage all media assets (images, videos) available for use in your designs.',
  },
  {
    src: '/GridSync_Designs_Preview.png',
    title: 'Design Preview',
    description: 'Preview created designs exactly as they will appear on your signage screens.',
  },
  {
    src: '/GridSync_Design_Editor.png',
    title: 'Design Editor',
    description: 'Customize layouts in the design editor by adding sections, pages, and choosing your media content.',
  },
  {
    src: '/GridSync_New_Design.png',
    title: 'Create New Design',
    description: 'Start a new design from scratch, choosing layout type, resolution, and content sections.',
  },
  {
    src: '/GridSync_Groups.png',
    title: 'Groups Management',
    description: 'Manage groups of clients, assign schedules, and organize deployments efficiently.',
  },
  {
    src: '/GridSync_Player.png',
    title: 'GridSync Player',
    description: 'The GridSync Player runs on client devices to display assigned content and designs based on the schedule.',
  },
];

const GridSync = () => {
  useEffect(() => {
    const sections = document.querySelectorAll('.gridsync-section');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.4 }
    );
    sections.forEach((section) => observer.observe(section));
    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <div className="gridsync-wrapper">
      <h1 className="gridsync-title">Welcome to GridSync by PRYCE</h1>
      <p className="gridsync-subtitle">Explore the interface and learn how each feature works.</p>

      {imageSections.map((section, index) => (
        <div key={index} className="gridsync-section">
          <div className="gridsync-image-container">
            <img src={section.src} alt={section.title} className="gridsync-image" />
          </div>
          <div className="gridsync-text">
            <h2>{section.title}</h2>
            <p>{section.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GridSync;
